<template>
<div id="app">
  <Header v-if="showHeader" />
  <keep-alive :include="KEEPALIVES">
    <router-view/>
  </keep-alive>
  <Footer v-if="showHeader" />
</div>
</template>

<script>
import Header from './components/Header.vue'
import Footer from './components/Footer.vue'
import { mapGetters } from 'vuex'
import { fetchBaikeDetails } from '@/api/api'
export default {
    name: 'App',
    components: {
        Header,
        Footer
    },
    props: {
        msg: String
    },
    data() {
        return {
        }
    },
    computed: {
        ...mapGetters(['KEEPALIVES']),
        showHeader() {
            // 默认显示Header，除非meta中明确设置为false
            return this.$route.meta?.showHeader !== false
        }
    },
    created() {
    // if(this.$router.path !== '/') {
    //   this.$router.replace('/')
    // }
    },
    mounted() {
        fetchBaikeDetails({
        }).then(r => {
            this.$store.commit('setJewelryEncycData', r.data)
        })
        //   this.$store.commit('setJewelryEncycData',
        //     {
        //     "code": 0,
        //     "msg": "成功",
        //     "data": {
        //         "details": {
        //             "title": "钻石",
        //             "category_id": "1",
        //             "views": "100",
        //             "content": "<p>钻石</p>",
        //             "create_time": "2022-08-02 18:01:05"
        //         },
        //         "left_list": [{
        //             "id": "1",
        //             "title": "彩色宝石",
        //             "list": [{
        //                 "id": "3",
        //                 "title": "刚玉",
        //                 "category_id": "1"
        //             }, {
        //                 "id": "2",
        //                 "title": "钻石",
        //                 "category_id": "1"
        //             }]
        //         }, {
        //             "id": "2",
        //             "title": "有机宝石"
        //         }, {
        //             "id": "5",
        //             "title": "玉石"
        //         }]
        //     }
        // })
    },
    methods: {}
}
</script>
<style lang="scss">
body,html,#app {
  width: 100%;
  height: 100%;
  // min-width: 1000px;
  overflow: auto;
}
</style>
